import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Translation */
import { translate } from "../translates"

/* Widget Intro — splash overlay shown while cities and categories load on app start */
class Intro extends Component {

    constructor() {
        super()

        /* State */
        this.state = {
            leaving: false,
            hidden: false
        }

        /* Keep the splash on screen for at least this long so it never flickers */
        this.startedAt = Date.now()
        this.minimumDuration = 1500
        /* Timer that triggers the leave animation */
        this.leaveTimeout = null
        /* Timer that removes the splash from the tree */
        this.hideTimeout = null
    }

    componentDidMount = () => {
        /* Data may already be in the store if it resolved before mount */
        if (this.props.data) {
            this.scheduleLeave()
        }
    }

    componentDidUpdate = previousProps => {
        /* Cities and categories just arrived — start leaving */
        if (!previousProps.data && this.props.data) {
            this.scheduleLeave()
        }
    }

    componentWillUnmount = () => {
        clearTimeout(this.leaveTimeout)
        clearTimeout(this.hideTimeout)
    }

    scheduleLeave = () => {
        /* Avoid scheduling twice */
        if (this.state.leaving) {
            return
        }

        const elapsed = Date.now() - this.startedAt
        const remaining = Math.max(this.minimumDuration - elapsed, 0)

        this.leaveTimeout = setTimeout(() => {
            this.setState({ leaving: true })

            /* Remove from the tree once the slide-up animation has finished */
            this.hideTimeout = setTimeout(() => {
                this.setState({ hidden: true })
            }, 600)
        }, remaining)
    }

    render = () => {
        if (this.state.hidden) {
            return null
        }

        let className = "intro"
        if (this.state.leaving) {
            className = "intro ended"
        }

        return (
            <div className={className}>
                <img src="/logo.png" alt="Bookify" />
                <p>{translate("Запись за пару кликов")}</p>
            </div>
        )
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        data: state.data,
        lang: state.lang
    }
}

/* Export */
export default connect(mapStateToProps)(Intro)
